import { ca } from '@cian/analytics';

export function trackTrapLinkClick(id: number) {
  ca('eventSite', {
    action: 'Click',
    category: 'build_house',
    label: 'trap_block',
    name: 'oldevent',
    products: [
      {
        id,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
}
